import { z } from 'zod';

import { PayoffId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GeneratePartialPayoffConfirmationSideEffectContext = BaseLoanIdSideEffect.extend({
  payoffId: PayoffId,
});
export const GeneratePartialPayoffConfirmationSideEffect = GeneratePartialPayoffConfirmationSideEffectContext.extend({
  type: z.literal('generatePartialPayoffConfirmation'),
});
export type GeneratePartialPayoffConfirmationSideEffect = z.infer<typeof GeneratePartialPayoffConfirmationSideEffect>;
